import { Link as JoyLink, LinkProps, Typography } from '@mui/joy';
import { LinkSimpleHorizontal } from '@phosphor-icons/react';

interface IProps extends LinkProps {
  withIcon?: boolean;
  highlight?: boolean;
}

export const Link = ({ withIcon, children, highlight = false, ...rest }: IProps) => {
  return (
    <JoyLink
      {...rest}
      sx={{
        ...(highlight && {
          backgroundColor: 'primary.100',
          color: 'primary.500',
        }),
        ...rest.sx,
      }}
    >
      {withIcon && (
        <Typography sx={{ marginX: 1 }}>
          <LinkSimpleHorizontal />
        </Typography>
      )}
      {children}
    </JoyLink>
  );
};
